'use client';

import { useEffect, useState } from 'react';

import { Breakpoints } from '../theme/breakpoints';

type BreakpointTypes = keyof typeof Breakpoints;

type Args = { minWidth: BreakpointTypes; maxWidth?: never } | { maxWidth: BreakpointTypes; minWidth?: never };

export const useMediaQuery = (args: Args) => {
  const { minWidth, maxWidth } = args;
  const query = `(${minWidth ? 'min-width' : 'max-width'}: ${Breakpoints[minWidth || maxWidth]})`;

  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia(query);

    const handleMediaQueryChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };
    setMatches(mediaQuery.matches);

    mediaQuery.addEventListener('change', handleMediaQueryChange);

    return () => {
      mediaQuery.removeEventListener('change', handleMediaQueryChange);
    };
  }, [query]);

  return matches;
};
